export default {
  beforeMount: (el, binding, vnode) => {
    el.setAttribute('target', '_blank')
    el.setAttribute('rel', 'noopener')
  },
}
